<style>
  .text-danger {
    color: #ff4444 ;
    }

    .card-header-formatting {
    padding-top: 16px;
    padding-bottom: 16px;
    background: linear-gradient(112.2deg, var(--sl-color-primary-400) 14.86%, var(--sl-color-primary-700) 102.08%);
    color: white;
  }
  .card-header-formatting a:visited{
    color: #f7be6a;
  }

  </style>

<div [formGroup]="currentAddress">
    <fadv-grid>
        <fadv-grid-row>
            <fadv-grid-col>
                    <fadv-typography type="label-medium" weight="500">Current Address</fadv-typography>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col>
                <fadv-typography type="label-small">{{ addressTooltip }}</fadv-typography>
            </fadv-grid-col>
        </fadv-grid-row>
    <fadv-grid-row>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-input 
                [invalid]="this.addressLine1Invalid"
                (blur)="showValidation('addressLine1')" 
                formControlName="addressLine1" 
                label="Address 1 *"></fadv-input>
                <span class="error" *ngIf="this.addressLine1Invalid == true">
                    <small *ngIf="currentAddress.get('addressLine1').hasError('required')" class="text-danger">Address is Required</small>
                    <small *ngIf="currentAddress.get('addressLine1').hasError('whitespace') && !currentAddress.get('addressLine1').hasError('required')" class="text-danger">Address cannot be empty</small>
                </span>
            </fadv-grid-col>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-input formControlName="addressLine2" label="Address 2"></fadv-input>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-input 
                [invalid]="this.zipInvalid"
                (blur)="showValidation('zip')" 
                (blur)="handleZipCodeChange($event)" 
                [maxlength]="5" 
                formControlName="zip"
                label="Postal Code *"></fadv-input>
                <span class="error" *ngIf="this.zipInvalid == true">
                    <small *ngIf="currentAddress.get('zip').hasError('required')" class="text-danger">Zip Code is Required</small>
                    <small *ngIf="currentAddress.get('zip').hasError('minlength') || currentAddress.get('zip').hasError('pattern')" class="text-danger">Zip Code must be 5 numbers</small>
                </span>
            </fadv-grid-col>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-input 
                [invalid]="this.cityInvalid"
                (blur)="showValidation('city')" 
                formControlName="city" 
                label="City / Town *"></fadv-input>
                <span class="error" *ngIf="this.cityInvalid == true">
                    <small *ngIf="currentAddress.get('city').hasError('required')" class="text-danger">City is Required</small>
                    <small *ngIf="currentAddress.get('city').hasError('whitespace') && !currentAddress.get('city').hasError('required')" class="text-danger">City cannot be empty</small>
                </span>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-input 
                [invalid]="this.stateInvalid"
                (blur)="showValidation('state')" 
                oninput="this.value = this.value.toUpperCase()" 
                maxlength="2" autocapitalize="on" 
                formControlName="state" 
                id="state" label="State *"></fadv-input >   
                    <span *ngIf="this.stateInvalid == true">
                        <small *ngIf="currentAddress.get('state').hasError('required')" class="text-danger">State is Required</small>
                        <small *ngIf="currentAddress.get('state').hasError('pattern')" class="text-danger">State cannot contain numbers or special characters</small>
                        <small *ngIf="currentAddress.get('state').hasError('whitespace') && !currentAddress.get('state').hasError('required')" class="text-danger">State cannot be empty</small>
                    </span>
            </fadv-grid-col>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-select formControlName="county" label="County *" hoist="true" scrollable="true">
                    <fadv-menu-item *ngFor="let county of counties" [checked]="county.Key === selectedCounty" value="{{county.Key}}">{{ county.Value }}</fadv-menu-item>
                </fadv-select>            
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col [col]="12">
                <fadv-select formControlName="country" label="Country *" hoist="true" scrollable="true">
                    <fadv-menu-item *ngFor="let country of countries" value="{{country.code}}">{{ country.name }}</fadv-menu-item>
                </fadv-select>
            </fadv-grid-col>
        </fadv-grid-row>
    </fadv-grid>
</div>
